import SearchCards from "./SearchCards";
import { roles } from "../../helper/constant";
import CardBox from "../../component/common/cardBox";
import { useNavigate } from "react-router-dom";
import { useLoginData } from "component/common/loginData";
import gameIcon from "../../assets/game-on.png";
import serviceIcon from "../../assets/service_icon.png";
import matchIcon from "../../assets/request_match.png";
import venueIcon from "../../assets/venue.png";
import { useDispatch } from "react-redux";
import { clearEventDetails, clearServiceDetails } from "store/slice/booking";
import { clearJoinRequestDetail } from "store/slice/profile";

export default function Home() {
  const navigate = useNavigate();
  const userData = useLoginData();
  const dispatch = useDispatch();
  const venueMenu = [
    {
      id: 1,
      title: "Event Card",
      description: "Explore exciting events happening",
      color: "bg-gradient-to-t from-[#F178B0] to-[#DB0C6E]",
      img: gameIcon,
      onClick: () => {
        dispatch(clearEventDetails());
        navigate("/event/card/new");
      },
    },
    {
      id: 2,
      title: "Service",
      description: "Access exclusive services and perks",
      color: "bg-gradient-to-t from-[#2BACE2] to-[#B2BBFF]",
      img: serviceIcon,
      onClick: () => {
        dispatch(clearServiceDetails());
        navigate("/event/request-service/new");
      },
    },
  ];

  const clubMenu = [
    {
      id: 3,
      title: "Game-On",
      description: "Find a Player",
      color: "bg-gradient-to-t from-[#DB0C6E] to-[#F178B0]",
      img: gameIcon,
      onClick: () => navigate("/club/game-on"),
    },
    {
      id: 4,
      title: "Service",
      description: "Request Sports Services",
      color: "bg-gradient-to-t from-[#2BACE2] to-[#B2BBFF]",
      img: serviceIcon,
      onClick: () => {
        dispatch(clearServiceDetails());
        navigate("/event/request-service/new");
      },
    },
    {
      id: 5,
      title: "Request Match",
      description: "Organize Games with Clubs",
      color: "bg-gradient-to-t from-[#52A027] to-[#99F368]",
      img: matchIcon,
      onClick: () => {
        dispatch(clearJoinRequestDetail());
        navigate("/club/match/new");
      },
    },
    {
      id: 6,
      title: "Venue",
      description: "Find & Book a Venue",
      color: "bg-gradient-to-t from-[#F38423] to-[#F8A35A]",
      img: venueIcon,
      onClick: () => navigate("/club/venue"),
    },
  ];

  const HomeMenu = userData?.userType === roles.CLUB ? clubMenu : venueMenu;

  return (
    <div className="min-h-screen bg-gray-100 md:p-5 p-3">
      <div className="container mx-auto md:mt-8 mt-6">
        <h1 className="text-md font-semibold mb-5">
          Hi, {userData?.name} 👋 Ready to Play?
        </h1>
        <CardBox list={HomeMenu} />
        {userData?.userType === roles.CLUB && <SearchCards />}
      </div>
    </div>
  );
}
